import teamImg1 from "../assets/images/team/Josef Renggli.webp";
import teamImg2 from "../assets/images/team/Ahlem Bel Hadj Ammar.jpg";
import teamImg3 from "../assets/images/team/Hichem-Aounallah.webp";
import teamImg4 from "../assets/images/team/Mehdi Gharbi.webp";
import teamImg5 from "../assets/images/team/Anis Wahabi.webp";
import teamImg6 from "../assets/images/team/Youssef Baltagi.webp";
import teamImg7 from "../assets/images/team/Francesco Zaniboni.webp";
import teamImg8 from "../assets/images/team/Ikbel Jebabli.webp";
import teamImg9 from "../assets/images/team/Chokri Fitouri.webp";
import teamImg10 from "../assets/images/team/Imene Neffati.webp";
import teamImg11 from "../assets/images/team/Elyes Chafter.webp";
import teamImg12 from "../assets/images/team/Cyrine Fayache-Picsart-AiImageEnhancer.webp";

const TeamList = [
  {
    id: 1,
    image: teamImg1,
    name: "S.E. M. Josef Renggli",
    role: "Ambassadeur de Suisse en Tunisie et en Libye",
    position: "Président d'honneur de la Chambre de Commerce et d'Industrie Tuniso Suisse",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/josef-renggli-366b8b4b/",
      },
    ],
    bio: [""],
  },
  {
    id: 2,
    image: teamImg2,
    name: "Ahlem Bel Hadj Ammar",
    position: "Présidente de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "CEO de Salammbô Shop",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/ahlem-bel-hadj-ammar-20aa8126/",
      },
    ],
    bio: [
      "Après des études d'art à Lausanne, suivies d'un premier cursus en cinéma et d'un second en architecture végétale, j'ai fait mes premiers pas dans l'entrepreneuriat en lançant mon projet 'Côté Parc'. Cette première expérience a consisté à proposer des plantes naturelles stabilisées. Par la suite, j'ai entamé l'aventure '3 Pommes', dédiée à la fabrication et à la commercialisation de chaises évolutives en bois pour bébés, inspirées du design scandinave.En parallèle, j'ai intégré la Chambre de commerce et d'industrie tuniso-suisse, où j'ai d'abord occupé le poste de secrétaire générale avant d'en devenir présidente. Ce rôle m'a permis de renforcer les liens économiques et culturels entre la Tunisie et la Suisse tout en soutenant des initiatives innovantes.Aujourd'hui, je dirige également 'Salammbô', un projet tuniso-suisse né d'une collaboration entre une Tunisienne et une Suisse, toutes deux passionnées de mode et de design, qui ont souhaité créer un pont entre les deux pays. Cette passion repose sur des valeurs fondamentales : le vivre-ensemble, le partage culturel et la solidarité. Nos créations cherchent à établir un lien entre la mode contemporaine et une inspiration artistique puisée dans le charme de l'artisanat tunisien.'Salammbô' est également un projet solidaire, soutenu par des partenariats avec de nombreux artisans locaux. Bien plus qu'un simple nom, 'Salammbô' incarne un véritable état d'esprit à travers lequel nous souhaitons transmettre la joie de vivre du peuple tunisien, portée par la vivacité des couleurs et une invitation à l'évasion. Enfin, notre ambition est de véhiculer une image positive de la Tunisie et de mettre en lumière ses nombreux atouts.",
    ],
  },
  {
    id: 3,
    image: teamImg3,
    name: "Hichem Aounallah",
    position: "Vice-Président de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "CEO de Bioprotection S.A",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/hichem-aounallah-7a79a241/",
      },
    ],
    bio: [
      "Mr Hichem AOUNALLAH est CEO de BIOPROTECTION S.A, une entreprise Tunisienne spécialisée dans la commercialisation de produits phytosanitaires et de fertilisants Sur le plan académique, Mr Hichem AOUNALLAH est diplômé de l'Ecole Supérieure d'Horticulture de Chott-Mariem, et titulaire d'un diplôme d'ingénieur paysagiste de l'Ecole Nationale Supérieure de Versailles.",
    ],
  },
  {
    id: 4,
    image: teamImg4,
    name: "Mehdi Gharbi",
    position: "Vice-Président de la chambre de commerce et d'industrie tuniso suisse",
    role: "Directeur des affaires corporatives et de la communication pour JTI en Tunisie et en Libye",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://tn.linkedin.com/in/mehdi-gharbi-13214317",
      },
    ],
    bio: [
      "Mehdi Gharbi est spécialiste en affaires publiques et diplomatie, fort de plus de 19 ans d'expérience dans les secteurs public et privé. Actuellement directeur des affaires corporatives et de la communication pour JTI en Tunisie et en Libye, il a occupé des postes stratégiques au sein du ministère des Affaires étrangères tunisien, ainsi qu'auprès d'organisations onusiennes. Son parcours inclut des missions diplomatiques à Washington et Pékin, où il a renforcé les relations bilatérales et promu la coopération économique. Titulaire de deux masters en relations internationales et en commerce international, il parle couramment l'arabe, le français, l'anglais et l'italien.",
    ],
  },
  {
    id: 5,
    image: teamImg5,
    name: "Anis Wahabi",
    position: "Trésorier de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "Expert-comptable",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://tn.linkedin.com/in/anis-wahabi-63573085",
      },
    ],
    bio: [
      "Anis WAHABI est expert-comptable, consultant senior et auteur spécialisé en finances publiques, gouvernance, stratégie et entrepreneuriat. Fort de plus de 25 ans d'expérience en Tunisie et à l'international, il intervient auprès de gouvernements, d'organisations internationales, d'entreprises, d'ONG et de structures d'accompagnement. Associé du cabinet AWT Audit & Conseil et membre de l'Ordre des Experts Comptables de Tunisie, il a contribué à de nombreuses réformes comptables, fiscales et organisationnelles en Afrique du Nord, en Afrique subsaharienne et au Moyen-Orient. Il accompagne également des initiatives d'innovation sociale et de développement local, notamment dans les domaines de l'économie sociale, de la durabilité et de l'entrepreneuriat à impact.Formateur expérimenté et conférencier, il est l'auteur de plusieurs ouvrages professionnels sur la gestion des associations, la comptabilité publique, les normes IPSAS et les IFRS. Il s'engage activement dans la société civile et participe à des dynamiques de transformation citoyennes.",
    ],
  },
  {
    id: 6,
    image: teamImg6,
    name: "Youssef Baltagi",
    position: "Secrétaire Général de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "CEO KESVIR",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/youssef-baltagi-0623483b",
      },
    ],
    bio: [
      "Fondateur de KESVIR, Youssef Baltagi est consultant et accompagne entreprises et institutions en stratégie, organisation et événementiel. Il est également Country Manager pour une ESN et s'implique dans plusieurs ONG et associations, œuvrant au développement du leadership et des partenariats internationaux.",
    ],
  },
  {
    id: 7,
    image: teamImg7,
    name: "Francesco Zaniboni",
    position: "Membre du Comité Exécutif de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "Managing Director chez MSC Croisières Tunisie",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/francesco-zaniboni-44b9b1129/",
      },
    ],
    bio: [
      "Je m'appelle Francesco Zaniboni et je suis le directeur général de MSC Mediterranean Shipping Company Tunisia. Dans le cadre de mes fonctions, je supervise nos opérations et nos initiatives stratégiques, en veillant à ce que nous continuions à croître et à réussir dans le secteur du transport maritime.Avec plus de 12 ans d'expérience dans le secteur du transport maritime, je me suis consacré à la croissance de MSC Tunisie et au renforcement de notre position sur le marché. Je suis titulaire d'un Master en Relations Internationales et d'un autre Master en Logistique, qui m'ont permis d'acquérir les connaissances et les compétences nécessaires pour exceller dans ce domaine.Je suis passionnée par le développement de relations commerciales solides entre la Tunisie et la Suisse, la promotion des opportunités commerciales et d'investissement. Mon engagement en faveur du développement durable et de l'innovation est au cœur de tout ce que je fais, et je suis fière de faire partie de la Chambre de commerce et d'industrie tuniso-suisse.",
    ],
  },
  {
    id: 8,
    image: teamImg8,
    name: "Ikbel Jebabli",
    position: "Membre du Comité Exécutif de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "CEO Palais Didon Ephad",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "#",
      },
    ],
    bio: [
      "Ikbel Jbebli, entrepreneur tunisien et professionnel de santé depuis 2007, est le fondateur du Palais Didon, médical-hôtel innovant dédié aux seniors. Il dirige également OXYGENA, leader en oxygénothérapie et hospitalisation à domicile en Tunisie.",
    ],
  },
  {
    id: 9,
    image: teamImg9,
    name: "Chokri Fitouri",
    position: "Membre du Comité Exécutif de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "Directeur Général – Phoenix Mecano Elcom",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "#",
      },
    ],
    bio: [
      "Ingénieur en Génie Mécanique diplômé de Uni of Applied Science Munich (Germany), titulaire d'un Master en Génie Industriel spécialisé en Modernisation et Optimisation des Entreprises de l'UVT de Tunis, Chokri Fitouri cumule plus de 25 ans d'expérience dans l'industrie, principalement au sein de multinationales allemandes et suisses implantées en Tunisie. Il a développé une expertise pointue dans la gestion de sites industriels, l'optimisation des processus de production, le management d'équipes pluridisciplinaires, la qualité industrielle ainsi que le pilotage de projets stratégiques incluant des démarches Lean Manufacturing, Kaizen et des coopérations internationales.",
    ],
  },
  {
    id: 10,
    image: teamImg10,
    name: "Imen Neffati",
    position: "Membre du Comité Exécutif de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "Responsable marchés export – PMI Tunisie",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "#",
      },
    ],
    bio: [
      "Pharmacienne de formation, avec un Master en Affaires Réglementaires, Imen Neffati a construit son parcours autour des enjeux de santé, de réglementation et de relations institutionnelles.Aujourd'hui Manager Corporate Affairs pour la Tunisie et la Libye chez Philip Morris, elle contribue à la gestion des relations institutionnelles en veillant à construire des échanges constructifs avec les parties prenantes, dans un esprit de dialogue et de collaboration. Au fil de son parcours, Imen a développé des compétences clés en négociation et en gestion des enjeux réglementaires. Elle croit en une approche humaine et constructive des affaires publiques, où l'écoute et la transparence sont au cœur de chaque interaction.",
    ],
  },
  {
    id: 11,
    image: teamImg11,
    name: "Elyes Chafter",
    position: "Conseiller juridique de la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "Avocat",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://tn.linkedin.com/in/elyes-chafter-417679151",
      },
    ],
    bio: [
      "Elyes Chafter est avocat inscrit au Barreau de Tunisie depuis 2014 et intervient en qualité de conseil juridique depuis 2009. Il est titulaire d'un Master en Common Law de l'Université de Carthage, d'un Master en Droit Économique de l'Université de Genève, ainsi que d'un Certificat en Droit Transnational de la même université. Il intervient principalement dans le domaine du Droit des affaires, en couvrant notamment les domaines suivants : ⦁ Droit des contrats, ⦁ Droit des sociétés, ⦁ Droit commercial, ⦁ Droit du travail, ⦁ Droit des PPP (Partenariats Public-Privé), ⦁ Financement de projet ⦁ Droit économique, ⦁ Droit de l'arbitrage, ⦁ Protection des données personnelles. Parallèlement à ses activités d'avocat-conseil, Elyes Chafter enseigne la recherche juridique et l'anglais juridique à l'Institut Supérieur de la Profession d'Avocat (l'école de formation des avocats). Il participe également aux jurys du concours d'entrée de cet institut et accompagne de nombreux étudiants dans la rédaction de leurs mémoires de fin d'études. Il travaille en arabe, français et anglais, ce qui lui permet de s'adapter à des contextes juridiques diversifiés.",
    ],
  },
  {
    id: 12,
    image: teamImg12,
    name: "Cyrine Fayache",
    position: "Executive Manager à la Chambre de Commerce et d'Industrie Tuniso-Suisse",
    role: "",
    social: [
      {
        id: 3,
        icon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/cyrinefayache/",
      },
    ],
    bio: [
      "Titulaire d'un master en Administration des Affaires, je suis passionnée par les enjeux du commerce international, les relations internationales et la diplomatie. Mon parcours m'a permis d'acquérir une solide expertise dans ces domaines, tout en développant une forte capacité à coordonner et gérer des projets dans des environnements interculturels et multinationaux.Actuellement, je travaille au sein de la Chambre de Commerce et d'Industrie Tuniso-Suisse, mon rôle me permet d'apporter une contribution significative à la promotion des échanges commerciaux et à la consolidation des relations économiques entre la Tunisie et la Suisse, tout en contribuant à la mise en œuvre de stratégies de développement pour soutenir les entreprises. Je suis également en charge de la coordination d'événements, un domaine qui constitue des occasions privilégiées pour promouvoir des projets d'envergure et faciliter les partenariats économiques.",
    ],
  },
];

export default TeamList;